(function avisVerifies() {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "avis-verifies";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  $(async () => {
    const configDesktop = 3;
    const configTablet = 2;
    const configMobile = 1;

    const splide = new Splide('.splide.avisverifies__container', {
      perPage: configDesktop,
      perMove: configDesktop,
      arrows: false,
      gap: '1.5rem',
      easing: 'ease-out',
      omitEnd: true,
      breakpoints: {
        1024: { perPage: configTablet, perMove: configTablet, arrows: false },
        768:  { perPage: configMobile, perMove: configMobile, arrows: false, gap: '1rem' }
      },
      i18n: {
        prev: "Slide précédente",
        next: "Slide suivante",
        slideX: "Aller à la slide %s",
        carousel: "carrousel",
        slide: "slide",
        select: "Sélectionner une slide à afficher",
        slideLabel: "%s sur %s"
      }
    });

    splide.on('pagination:updated', (data) => {
      data.items.forEach((item, index) => {
        const perPage = window.innerWidth >= 1024 ? configDesktop
                      : window.innerWidth >= 560 ? configTablet
                      : configMobile;
        const start = index * perPage + 1;
        const end   = Math.min(start + perPage - 1, splide.length);

        item.button.ariaLabel   = `Afficher les avis clients ${start} à ${end}`;
        item.button.ariaCurrent = item.button.ariaSelected;
        item.button.removeAttribute('tabindex');
      });
    });

    const gradeValueBlock = document.querySelector('.avisverifies #grade-value > span');
    const globalRate = gradeValueBlock
      ? Number(gradeValueBlock.textContent.trim().replace(',', '.'))
      : 0;

    const createStar = (type, percentage) => {
      const star = document.createElement('div');
      star.classList.add('star', type);          

      if (type === 'partial' && typeof percentage === 'number') {
        star.style.setProperty('--star-remainder-percentage', `${percentage}%`);
      }
      return star;
    };

    const generateStars = (percentage) => {
      const container = document.querySelector('#rating-stars');
      if (!container) return;

      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      const totalStars   = 5;
      const fullStars    = Math.floor(Math.min(percentage, 100) / 20);          
      const remainderPct = ((Math.min(percentage, 100) % 20) * 5);               

      for (let i = 0; i < fullStars; i++) {
        container.appendChild(createStar('full'));
      }

      if (fullStars < totalStars) {
        container.appendChild(createStar('partial', remainderPct));
      }
    };

    const percentageRate = (globalRate / 5) * 100;
    generateStars(percentageRate);   

    splide.mount();

    if (splide.state.is(Splide.STATES.IDLE)) {
      const { Elements } = splide.Components;
      Elements.list.removeAttribute('role');
      Elements.slides.forEach(item => item.removeAttribute('role'));
    }
  });
})();
